import deepFreeze from 'deep-freeze';

/** Default layout. */
export const DefaultLayout = deepFreeze({
  bottom: {
    height: 250
  },
  left: {
    maxWidth: 480,
    minWidth: 240
  },
  right: {
    width: 240
  }
});
